export default __webpack_public_path__ + "static/media/peanut.db5aa5b0.svg";